import React from 'react';
import assign from 'object-assign';

import AddressStore from '../../stores/AddressStore';
import AddressActions from '../../actions/AddressActionCreator';
import CountryStore from '../../stores/CountryStore';
import CountryActions from '../../actions/CountryActionCreator';
import { Card, CardText } from 'material-ui/Card';
import Form from '../Common/Form.react';
import TextField from '../Common/TextField';
import SelectField from '../Common/SelectField';
import MenuItem from 'material-ui/MenuItem';

const AddressForm = React.createClass({

    getInitialState: function() {

        return {

            isEdit: (this.props.routeParams.id !== undefined && !!this.props.routeParams.id.match(/\d+/)),

            details: {
                name: '',
                address1: '',
                address2: '',
                address3: '',
                city: '',
                state: '',
                postalCode: '',
                countryId: 235,
                longitude: '',
                latitude: '',
            },
            countries: [],
            dropdowns: {
                countries: CountryStore.getAll(),
            }
        }
    },

    componentDidMount: function() {
        if (this.state.isEdit) {
            AddressStore.addChangeListener(this.onChange);
            AddressActions.getById(this.props.routeParams.id);
        }
        CountryStore.addChangeListener(this.onChange);
        CountryActions.getAll();
    },

    componentWillUnmount: function() {
        CountryStore.removeChangeListener(this.onChange);
    },

    submitForm: function (model) {

        if(!this.state.isEdit)
        {
            return AddressActions.save(model);
        } else {
            return AddressActions.update(this.props.routeParams.id, model);
        }

    },

    render: function() {

        const formTitle = (!this.state.isEdit ? 'New address' : this.state.details.name);

        return (

            <Form
                title={formTitle}
                onSave={this.submitForm}
                redirectTo={false}
            >
                <Card className="cent-card">
                    <CardText>
                        <TextField
                            name="name"
                            value={this.state.details.name}
                            validations="minLength:2,maxLength:80"
                            validationError="Please use only numbers and letters, at least 2"
                            floatingLabelText="Name"
                            hintText="Name"
                            required
                        />
                        <TextField
                            name="address1"
                            value={this.state.details.address1}
                            validations="minLength:2,maxLength:120"
                            validationError="Please use only numbers and letters, at least 2"
                            floatingLabelText="Line 1"
                            hintText="Line 1"
                            required
                        />
                        <TextField
                            name="address2"
                            value={this.state.details.address2}
                            validations="minLength:2,maxLength:120"
                            validationError="Please use only numbers and letters, at least 2"
                            floatingLabelText="Line 2"
                            hintText="Line 2"
                        />
                        <TextField
                            name="address3"
                            value={this.state.details.address3}
                            validations="minLength:2,maxLength:120"
                            validationError="Please use only numbers and letters, at least 2"
                            floatingLabelText="Line 3"
                            hintText="Line 3"
                        />
                        <TextField
                            name="city"
                            value={this.state.details.city}
                            validations="minLength:2,maxLength:120"
                            validationError="Please use only numbers and letters, at least 2"
                            floatingLabelText="City"
                            hintText="City"
                        />
                        <TextField
                            name="state"
                            value={this.state.details.state}
                            validations="minLength:2,maxLength:120"
                            validationError="Please use only numbers and letters, at least 2"
                            floatingLabelText="State"
                            hintText="State"
                        />

                        <TextField
                            name="postalCode"
                            value={this.state.details.postalCode}
                            validations="minLength:2,maxLength:12"
                            validationError="Please use only numbers and letters, at least 2"
                            floatingLabelText="PostalCode"
                            hintText="PostalCode"
                            required
                        />

                <SelectField
                    name="countryId"
                    value={this.state.details.countryId}
                    floatingLabelText="Country"
                    hintText="Country"
                    required
                >
                    <MenuItem
                        key={0}
                        value={0}
                        primaryText="Select"
                    />
                    {this.state.dropdowns.countries.map(function(country) {
                        return (
                            <MenuItem
                                key={country.id}
                                value={country.id}
                                primaryText={country.name}
                            />
                        )
                    })}
                </SelectField>

                        <TextField
                            name="longitude"
                            value={this.state.details.longitude}
                            validations="minLength:2,maxLength:20"
                            validationError="Please use only numbers and letters, at least 2"
                            floatingLabelText="longitude"
                            hintText="longitude"
                        />

                        <TextField
                            name="latitude"
                            value={this.state.details.latitude}
                            validations="minLength:2,maxLength:20"
                            validationError="Please use only numbers and letters, at least 2"
                            floatingLabelText="latitude"
                            hintText="latitude"
                        />
                    </CardText>
                </Card>
            </Form>
        )
    },

     onChange: function() {

        let details = this.state.details;
        let dropdowns = this.state.dropdowns;

        if(this.state.isEdit) {
            details = assign({}, this.state.details, AddressStore.getById(this.props.routeParams.id));
        }

        dropdowns.countries = CountryStore.getAll();

        this.setState({
            details: details,
            dropdowns: dropdowns
        });
    }
});

export default AddressForm;
